// Breadcrumb so the board-first moment + tour survives a signup session that
// never finishes its auto-login (tab closed during the 5s setTimeout, network
// drop). Stashed at register() success — before the risky delay — and consumed
// by the normal Login form on the first matching sign-in.
// ponytail: single pending slot + localStorage, so it's per-device only. A
// cross-device first login (signup on phone, log in on laptop) still misses it;
// upgrade to a server flag (hasLoggedIn / default boardId) if that matters.
const KEY = 'b4igo:pendingFirstLogin'

export const stashPendingFirstLogin = (email?: string, boardId?: string): void => {
  if (!email || !boardId) return
  try {
    localStorage.setItem(KEY, JSON.stringify({ email, boardId }))
  } catch {
    /* localStorage unavailable — first-login moment just falls back to /home */
  }
}

// Returns the stashed boardId if it matches this email (and clears it), else null.
export const consumePendingFirstLogin = (email?: string): string | null => {
  try {
    const raw = localStorage.getItem(KEY)
    if (!raw) return null
    const pending = JSON.parse(raw)
    if (email && pending?.email !== email) return null
    localStorage.removeItem(KEY)
    return pending?.boardId || null
  } catch {
    return null
  }
}
